export default "__VITE_ASSET__ePJoOGe6__"